import React from 'react';
import { motion } from 'framer-motion';
import { HardHat, Laptop, ArrowRight } from 'lucide-react';
interface MeetHostSlideProps {
  content: {
    headline: string;
    bullets: string[];
  };
}
export function MeetHostSlide({
  content
}: MeetHostSlideProps) {
  return <div className="bg-[#1C1C1C] rounded-2xl min-h-[600px] flex overflow-hidden" data-id="element-172">
      {/* Left Side - Visual */}
      <div className="w-2/5 bg-[#017C6D] p-12 flex flex-col items-center justify-center relative" data-id="element-173">
        <div className="absolute top-0 right-0 w-full h-full bg-gradient-to-br from-[#0FB07D]/20 to-transparent" data-id="element-174" />
        <motion.div initial={{
        scale: 0.8,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        duration: 0.5
      }} className="relative z-10 flex flex-col items-center" data-id="element-175">
          <div className="w-48 h-48 rounded-full overflow-hidden mb-8 shadow-2xl border-4 border-[#0FB07D]" data-id="element-176">
            <img src="https://cdn.magicpatterns.com/uploads/1VvcNHgPcmCyH6oaRmng8T/kevheadshot1.jpg" alt="Kevin Rogers" className="w-full h-full object-cover" data-id="element-177" />
          </div>
          <h3 className="text-4xl font-bold text-white mb-2" data-id="element-178">Kevin Rogers</h3>
          <p className="text-[#0FB07D] text-xl font-semibold tracking-wide" data-id="element-179">
            VIRIDIA ANALYTICS
          </p>
        </motion.div>
      </div>

      {/* Right Side - Content */}
      <div className="w-3/5 p-16 flex flex-col justify-center bg-[#1C1C1C]" data-id="element-180">
        <motion.h2 initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-4xl font-bold text-[#F5F5F5] mb-12" data-id="element-181">
          {content.headline}
        </motion.h2>

        <div className="space-y-8" data-id="element-182">
          {content.bullets.map((bullet, index) => {
          const [boldPart, ...rest] = bullet.split(':');
          return <motion.div key={index} initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.3 + index * 0.2
          }} className="flex items-start gap-4" data-id="element-183">
                <div className="w-2 h-2 rounded-full bg-[#0FB07D] mt-3 flex-shrink-0" data-id="element-184" />
                <p className="text-xl text-[#F5F5F5]/80 leading-relaxed" data-id="element-185">
                  {rest.length > 0 ? <>
                      <strong className="text-[#F5F5F5]" data-id="element-186">{boldPart}:</strong>
                      {rest.join(':')}
                    </> : <strong className="text-[#F5F5F5]" data-id="element-187">{bullet}</strong>}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </div>;
}
export default MeetHostSlide;